"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ComparisonHeader_1 = require("./ComparisonHeader");
exports.default = ComparisonHeader_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/cards/CardComparisonContainer/components/ComparisonHeader/index.js
// module id = 1320
// module chunks = 8